<template>
    <!-- the standings of the leagues of one league group, one tab per league -->
    <div class="home-standings">
        <!-- one line, always: the tabs scroll sideways, so every table starts at the same height as its neighbour -->
        <div class="home-standings__head">
            <div ref="tabs" class="home-standings__leagues" @wheel="onTabsWheel">
                <button
                    v-for="league in groupLeagues"
                    :key="league.id"
                    type="button"
                    class="home-standings__league"
                    :class="{ 'home-standings__league--active': selectedLeague && selectedLeague.id === league.id }"
                    @click="selectedLeague = league"
                >
                    {{ league.title }}
                </button>
            </div>
            <router-link v-if="selectedLeague" :to="{ name: 'League', params: { id: selectedLeague.id } }" class="home-standings__more">
                Όλη η λίγκα <v-icon x-small>mdi-arrow-right</v-icon>
            </router-link>
        </div>
        <league-standings :ranking="ranking" compact />
    </div>
</template>

<script>
    import leagueService from '@/services/league.js'
    import LeagueStandings from '@/components/LeagueStandings'

    export default {
        components: { LeagueStandings },
        props: {
            leagueGroup: {
                type: Object,
                default: () => ({})
            },
            leagues: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                ranking: [],
                selectedLeague: null
            }
        },
        computed: {
            groupLeagues() {
                return this.leagues.filter(league => league.leagueGroup && league.leagueGroup.id === this.leagueGroup.id)
            }
        },
        watch: {
            selectedLeague(newLeague) {
                if (newLeague) {
                    this.getRankingByLeague(newLeague.id)
                }
            },
            leagues: {
                handler(newVal) {
                    // when the leagues are loaded, start with the first league of the group
                    if (newVal && newVal.length && !this.selectedLeague) {
                        this.selectedLeague = this.groupLeagues[0] || null
                    }
                },
                immediate: true
            }
        },
        methods: {
            // a mouse wheel scrolls the tabs sideways, when they do not fit
            onTabsWheel(event) {
                const el = this.$refs.tabs
                if (!el || el.scrollWidth <= el.clientWidth || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return
                event.preventDefault()
                el.scrollLeft += event.deltaY
            },
            // the standings are always those of the regular season, whatever the active phase
            getRankingByLeague(leagueId) {
                this.$store.dispatch('ensureConfig').catch(() => null).then(() => {
                    const config = this.$store.getters.getConfig || {}
                    return leagueService.getRankingByLeague(leagueId, config.activeSeasonId, 'regular_season')
                }).then(resp => {
                    if (this.selectedLeague && this.selectedLeague.id === leagueId) {
                        this.ranking = resp.data
                    }
                }).catch(() => {
                    this.ranking = []
                })
            }
        }
    }
</script>

<style scoped>
.home-standings__head {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 44px;
    margin-bottom: 8px;
}

.home-standings__leagues {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1 1 auto;
    min-width: 0;
    padding: 4px 24px 4px 2px;
    overflow-x: auto;
    scrollbar-width: none;

    /* fade on the right edge: there are more tabs to scroll to */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-mask-image: linear-gradient(90deg, #000 calc(100% - 24px), transparent);
    mask-image: linear-gradient(90deg, #000 calc(100% - 24px), transparent);
}

.home-standings__leagues::-webkit-scrollbar {
    display: none;
}

.home-standings__league {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 6px 14px;
    border-radius: 999px;
    background: #fff;
    color: #232323;
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    box-shadow: 0 1px 4px rgba(35, 35, 35, 0.1);
    transition: background 0.15s;
}

.home-standings__league:hover {
    background: #e0f2f1;
}

.home-standings__league--active,
.home-standings__league--active:hover {
    background: #232323;
    color: #fff;
    box-shadow: inset 0 -3px 0 #03e5b7;
}

.home-standings__more {
    flex: 0 0 auto;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #009688 !important;
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    text-decoration: none;
}
</style>
